export default __webpack_public_path__ + "media/images/tenant/timeline/step_1-71bac2e1903b67cdc4c859a7d40c8eaa.jpg";